<template>
  <div
    id="app"
    :class="{'screen':$store.state.style.screen}"
  >
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style >
body {
  min-width: 1100px;
}
</style>